import { useApi } from "../../api/hooks/use-api.ts";
import { ApiResponseType } from "../../api/types.ts";
import { ApiMethod } from "../../api/types.ts";
import { asArray, withArrayPayload, withObjectPayload } from "../../api/payload.ts";

export const useOrdersApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is the order array. Error: payload is the error object.
    const getOrders = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=orders');

        return response.then(withArrayPayload);
    };

    // Active exam projects (one per exam/verification run) for grouping orders:
    // [{ id, name, exam_date, registration_deadline }] (unix timestamps).
    // Resolves to the array itself, empty on failure.
    const getExamProjects = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=examProjects');

        return response.then(data => (data.type === ApiResponseType.OK ? asArray(data.payload) : []));
    };

    const cancelOrder = async (orderId:number|string) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=cancelOrder', {
            order_id: orderId,
        });

        return response.then(withObjectPayload);
    };

    // Request the early eligibility check (§ 356 Abs. 4 / § 357 Abs. 8 BGB) on
    // already-created verification orders, after the fact.
    const postOrderEarlyCheck = async (orderIds:Array<number|string>) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=orderEarlyCheck', {
            order_ids: orderIds,
        });

        return response.then(withObjectPayload);
    };

    // Upload the Level I certificate for an order registered with
    // "reiche ich bis spätestens zum Anmeldeschluss nach". The backend stores the
    // files in the order's upload folder and sets educational_certificate;
    // certificate_proof keeps the original choice.
    const postOrderCertificate = async (orderId:number|string, files:Array<{ filename:string, payload:string }>) => {
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=orderCertificate', {
            order_id: orderId,
            filenames: files.map(file => file.filename),
            payloads: files.map(file => file.payload),
        });

        return response.then(withObjectPayload);
    };

    return { getOrders, getExamProjects, cancelOrder, postOrderEarlyCheck, postOrderCertificate };
};
